import {
  Paper,
  Stack,
  Typography,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import React from "react";
import useExcelSelection from "./excelSelection";

export default function CustomDatasets() {
  const { address, values, text } = useExcelSelection();
  const hasHeader = values.length > 0 && values[0].every((c) => typeof c === "string" || c === null);

  const header = hasHeader ? text[0] : null;
  const rows = hasHeader ? text.slice(1) : text;
  return (
    <Paper elevation={0} sx={{ p: 2 }}>
      <Stack direction="row" alignItems="baseline" justifyContent="space-between" mb={1}>
        <Typography variant="h6" fontWeight={600}>
          Selection Preview
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {address || "—"}
        </Typography>
      </Stack>
      <Divider sx={{ mb: 1 }} />
      <TableContainer sx={{ maxHeight: 420, borderRadius: 2 }}>
        <Table size="small" stickyHeader>
          {header && (
            <TableHead>
              <TableRow>
                {header.map((h, i) => (
                  <TableCell key={i} sx={{ fontWeight: 700 }}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {rows.map((r, ri) => (
              <TableRow key={ri} hover>
                {r.map((c, ci) => (
                  <TableCell key={ci}>{c}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
        Select any range in Excel to refresh this table.
      </Typography>
    </Paper>
  );
};
